module.exports = __webpack_public_path__ + "static/cooking.8b8fbbf2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/examples/microwave-example/cooking.jpg
// module id = 1007
// module chunks = 240162396545425